var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTmsClockTowerInact(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 5.5,
    stroke: "#D1D5DB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_561_3951)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.3335 17.0976V12.1109C9.3335 10.5776 10.5802 9.33089 12.1135 9.33089H12.6668V15.3776L9.3335 17.0976ZM16.7868 9.33089H13.7802V15.4909L17.0668 18.7776H22.6668V15.2109C22.6268 15.2509 22.5935 15.2909 22.5602 15.3309L21.5268 16.3376C21.0135 16.8376 20.3335 17.1109 19.6135 17.1109C18.8935 17.1109 18.2135 16.8376 17.7002 16.3309L16.6802 15.3376C15.8802 14.5376 15.4468 13.4909 15.4468 12.3776C15.4468 11.2642 15.8802 10.2176 16.6668 9.43089C16.7068 9.39089 16.7468 9.35755 16.7868 9.32422V9.33089ZM16.1002 19.3842L13.1202 16.4042L9.3335 18.3442V19.8842C9.3335 21.4176 10.5802 22.6642 12.1135 22.6642H13.6402L16.1002 19.3842ZM15.0268 22.6642H19.8868C21.4202 22.6642 22.6668 21.4176 22.6668 19.8842H17.1135L15.0335 22.6642H15.0268Z",
    fill: "#D1D5DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.767 10.2254C21.1937 9.65203 20.427 9.33203 19.607 9.33203C18.787 9.33203 18.027 9.65203 17.447 10.2254C16.8737 10.8054 16.5537 11.572 16.5537 12.3854C16.5537 13.1987 16.8737 13.972 17.4537 14.552L18.4737 15.552C18.787 15.8587 19.2004 16.012 19.607 16.012C20.0137 16.012 20.4337 15.8587 20.747 15.552L21.767 14.5454C22.347 13.972 22.667 13.2054 22.667 12.3854C22.667 11.5654 22.347 10.8054 21.767 10.2254ZM19.607 13.2187C19.147 13.2187 18.7737 12.8454 18.7737 12.3854C18.7737 11.9254 19.147 11.552 19.607 11.552C20.067 11.552 20.4404 11.9254 20.4404 12.3854C20.4404 12.8454 20.067 13.2187 19.607 13.2187Z",
    fill: "#D1D5DB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_561_3951"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.3333,
    height: 13.3333,
    fill: "white",
    transform: "translate(9.3335 9.33203)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTmsClockTowerInact);
export default __webpack_public_path__ + "static/media/tmsClockTowerInact.33cf896c01e985494037fc28d45cab93.svg";
export { ForwardRef as ReactComponent };